import React, { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import ProductTable from 'components/productTable';
import { FormGroup } from '@mui/material';
import { Col, Row, Label, Input } from 'reactstrap';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import helperFunction from 'constants/helperFunction';
import axios from 'constants/axios';

let monthArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
let date = new Date();

const SellingProductTab = (props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [filterValueTop, setFilterValueTop] = useState(monthArray[date.getMonth()] + ' ' + date.getFullYear())
  const [filterValueLeast, setFilterValueLeast] = useState(monthArray[date.getMonth()] + ' ' + date.getFullYear())
  const [month, setMonth] = useState(monthArray[date.getMonth()])
  const [year, setYear] = useState(date.getFullYear())
  const [month1, setMonth1] = useState(monthArray[date.getMonth()])
  const [year1, setYear1] = useState(date.getFullYear())
  const [selectedTab, setSelectedTab] = useState('')
  const [yearList, setYearList] = useState([])
  const [topFive, setTopFive] = useState('')
  const [leastFive, setLeastFive] = useState('')

  useEffect(() => {
    let years = helperFunction.yearList();
    setYearList(years)
    let data = {
      user_type: 'buyer',
      id: props.id,
      month: monthArray[date.getMonth()],
      year: date.getFullYear()
    }
    axios.post('product/top5least5', data).then(result => {
      if (result.data.error) {
        console.log("error", result.data)
      } else {
        setTopFive(result.data.top5)
        setLeastFive(result.data.least5)
        setAnchorEl(null)
      }
    }).catch(error => {
      console.log("error catch", error)
    });
  }, [])

  const handleClick = (event, key) => {
    setAnchorEl(event.currentTarget)
    setSelectedTab(key)
  }

  const handleClose = (e) => {
    e.preventDefault();
    setAnchorEl(null)
  }

  const handleApplyFilter = async (e) => {
    e.preventDefault();
    let data = {
      user_type: 'buyer',
      id: props.id,
      month: month,
      year: year
    }
    await axios.post('product/top5least5', data).then(result => {
      if (result.data.error) {
        console.log("error", result.data)
      } else {
        setTopFive(result.data.top5)
        setLeastFive(result.data.least5)
        setAnchorEl(null)
        setFilterValueTop(month + ' ' + year)
        setMonth1(month)
        setYear1(year)
        setFilterValueLeast(month + ' ' + year)
      }
    }).catch(error => {
      console.log("error catch", error)
    });
  }

  const handleResetFilter = async (e, filter) => {
    e.preventDefault();
    setMonth(monthArray[date.getMonth()])
    setYear(date.getFullYear())
    setMonth1(month)
    setYear1(year)
    setFilterValueTop(monthArray[date.getMonth()] + ' ' + date.getFullYear())
    setFilterValueLeast(monthArray[date.getMonth()] + ' ' + date.getFullYear())
    let data = {
      user_type: 'buyer',
      id: props.id,
      month: monthArray[date.getMonth()],
      year: date.getFullYear()
    }
    await axios.post('product/top5least5', data).then(result => {
      if (result.data.error) {
        console.log("error", result.data)
      } else {
        setTopFive(result.data.top5)
        setLeastFive(result.data.least5)
        setAnchorEl(null)
      }
    }).catch(error => {
      console.log("error catch", error)
    });
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-xl-6 col-12">
          <div className="jr-card">
            <div className="jr-card-header d-flex align-items-center">
              <div className="mr-auto">
                <h3 className="d-inline-block mb-0">Top 10 Bought Products</h3>
                {
                  filterValueTop === '' ? null : <span className="text-white badge badge-success">{filterValueTop}</span>
                }
              </div>
              <IconButton className="icon-btn" onClick={(e) => handleClick(e, 'top')}>
                <i className="zmdi  zmdi-filter-list" />
              </IconButton>
            </div>
            <ProductTable value={topFive} />
          </div>
        </div>

        <div className="col-xl-6 col-12">
          <div className="jr-card">
            <div className="jr-card-header d-flex align-items-center">
              <div className="mr-auto">
                <h3 className="d-inline-block mb-0">Least 10 Bought Products</h3>
                {
                  filterValueLeast === '' ? null : <span className="text-white badge badge-success">{filterValueLeast}</span>
                }
              </div>
              <IconButton className="icon-btn" onClick={(e) => handleClick(e, 'top')}>
                <i className="zmdi  zmdi-filter-list" />
              </IconButton>
            </div>
            <ProductTable value={leastFive} />
          </div>
        </div>
      </div>

      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(e) => handleClose(e)}
      >
        <MenuItem className="filterBody">
          <div className="flex">
            <Row form>
              <Col md={6} xl={6} xs={6} lg={6}>
                <FormGroup>
                  <Label for="exampleSelect">Select Month</Label>
                  <Input type="select" value={selectedTab === 'top' ? month : month1} name="select" onChange={(e) => selectedTab === 'top' ? setMonth(e.target.value) : setMonth1(e.target.value)} id="exampleSelect">
                    {
                      monthArray.map((value, key) => {
                        return <option key={key} value={value}>{value}</option>
                      })
                    }
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6} xl={6} xs={6} lg={6}>
                <FormGroup>
                  <Label for="exampleSelect">Select Year</Label>
                  <Input type="select" value={selectedTab === 'top' ? year : year1} onChange={(e) => selectedTab === 'top' ? setYear(e.target.value) : setYear1(e.target.value)} name="select" id="exampleSelect">
                    {
                      yearList.map((year, key) => {
                        return <option key={key} value={year}>{year}</option>
                      })
                    }
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div style={{ paddingTop: 15 }} >
              <Button variant="contained" className='filterButton' onClick={(e) => handleApplyFilter(e)} color='primary'>Apply Filter</Button>
              <Button variant="contained" className='filterButton' onClick={(e) => handleResetFilter(e)} color='primary'>Reset Filter</Button>
            </div>
          </div>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default SellingProductTab;